const resultFunction = (configData) => (provider) => configData?.providers?.[provider] ?? {}

const providerConfigSelectorDefinition = {
  id: 'providerConfig',
  resultFunction,
  dependencies: [{ selector: 'configData' }],
}

export default providerConfigSelectorDefinition
